// extracted by mini-css-extract-plugin
module.exports = {"option":"Option__option__7WFWB","selectedFont":"Option__selectedFont__17ZYV"};